import { languageIndex } from "@utils";
export const EDUCATION_NEW_TYPE_OPTIONS = [
    "Secondary education",
    "Vocational education",
    "Secondary vocational education",
    "Higher education / Bachelor",
    "Higher education / Master",
    "Postgraduate education / PhD",
];
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        title: ["Education", "Образование"][index],
        subtitle: ["Please complete this section. It is required.", "Заполните этот раздел."][index],
        addEducation: ["Add Education", "Добавить образование"][index],
        educationType: ["Education type", "Тип образования"][index],
        institutionName: ["Institution name", "Название учреждения"][index],
        specialization: ["Specialization", "Специализация"][index],
        graduationOrExpected: ["Graduation", "Год выпуска"][index],
        educationTypePlaceholder: ["Select education type", "Выберите тип образования"][index],
        institutionNamePlaceholder: ["Institution name", "Название учреждения"][index],
        specializationPlaceholder: ["Specialization", "Специализация"][index],
        graduationYearPlaceholder: ["Select year", "Выберите год"][index],
        graduationYearInProgress: ["In progress", "В процессе"][index],
    };
};
